export type CrossJoinTargetProduct = 'confluence' | 'jira-product-discovery' | 'loom';

export const ProductDisplayNames = {
	confluence: 'Confluence',
	'jira-product-discovery': 'Jira Product Discovery',
	loom: 'Loom',
};

export type CrossJoinIntegraton =
	| 'crossJoinNudgesConfluence'
	| 'crossJoinNudgesJiraToJpd'
	| 'crossJoinNudgesJiraToLoom'
	| 'crossJoinNudgesYourWork';

export type AccessRequestType =
	| 'ACCESS_GRANTED'
	| 'PENDING_REQUEST_CREATED'
	| 'ACCESS_EXISTS'
	| 'VERIFICATION_REQUIRED'
	| 'PENDING_REQUEST_EXISTS'
	| 'DENIED_REQUEST_EXISTS'
	| 'APPROVED_REQUEST_EXISTS'
	| 'FORBIDDEN';

export type AccessRequestResponse = {
	results: {
		[resource: string]: AccessRequestType;
	};
};
